import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { HEADERS, HEADER_VALUES, APPLICATION_TYPE } from '../constants/global.constants';
import { HelperService } from 'src/app/services/helper.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  accessToken: any;
  constructor(
    private helperService: HelperService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

   /* if (sessionStorage.getItem('auth-token')) {
      request = this.addToken('bop-xxx-zzz-001', request);
    }*/
    //request = this.addToken('bop-xxx-zzz-001', request);
    request = this.addHeaders(request);
    this.helperService.setRequests(request);
    this.helperService.setLoader(true);

    return next.handle(request).pipe(
      tap(response => {
        if (response instanceof HttpResponse) {
          this.helperService.removeHttpRequest(request);
        }
      }),
      finalize(() => {
        this.helperService.removeHttpRequest(request);
      })
    );
  }

  addToken(token: any, req: HttpRequest<any>): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set(HEADERS.AUTHORIZATION, `${HEADER_VALUES.BEARER} ${token}`)
    });
  }

  addHeaders(req: HttpRequest<any>): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set(HEADERS.ALLOW_ORIGIN, '*')
    });
  }

}
